export default __webpack_public_path__ + "assets/png/8a12b1dd44d101726361a2eaaf1d2094.png";